import { createFeature, createReducer, on } from "@ngrx/store";
import { cloneDeep } from "lodash";
import { IntegrationDetail } from "src/app/core/interfaces/integration-detail.interface";
import * as integrationsActions from './integrations.actions';
import { ID } from "src/app/core/definitions/types";


export interface IntegrationsState {
    current: IntegrationDetail | null;
    integrations: IntegrationDetail[];
    integrationDrafts: IntegrationDetail[];
    creationMode: boolean;
    modified: boolean;
    isLoadingList: boolean;
    healthStatuses: Record<ID, string>;
}

export const initialState: IntegrationsState = {
    current: null,
    creationMode: false,
    integrations: [],
    integrationDrafts: [],
    modified: false,
    isLoadingList: false,
    healthStatuses: {}
};

export const integrationsFeature = createFeature({
    name: 'integrations',
    reducer: createReducer(
        initialState,
        on(integrationsActions.getIntegrations, (state) => {
            return { ...state, integrations: [], isLoadingList: true };
        }),
        on(
            integrationsActions.getIntegrationsSuccess,
            (state, { integrations }) => ({
                ...state,
                integrations,
                isLoadingList: false
            })
        ),
        on(integrationsActions.getIntegrationsFail, (state) => ({
            ...state,
            isLoadingList: false
        })),
        on(integrationsActions.getIntegrationsHealthSuccess, (state, { healthStatuses }) => ({
            ...state,
            healthStatuses
        })),
        on(integrationsActions.deleteIntegration, (state, { id }) => ({
            ...state,
            isLoadingDetail: true
        })),
        on(
            integrationsActions.deleteIntegrationSuccess,
            (state, { id }) => ({
                ...state,
                detail: null,
                current: null,
                modified: false,
                fieldDefinitionValidations: {},
                integrations: state.integrations.filter((p) => p.id !== id),
            })
        ),
        on(integrationsActions.deleteIntegrationFail, (state) => ({
            ...state,
            isLoadingDetail: false
        })),
        on(integrationsActions.setDraft, (state, { draft }) => ({
            ...state,
            current: cloneDeep(draft),
            creationMode: true,
            modified: true,
        })),
        on(integrationsActions.setCurrent, (state, { current }) => ({
            ...state,
            current: cloneDeep(current),
            creationMode: false,
            modified: false,
        })),
        on(integrationsActions.upsertIntegration, (state) => {
            return {
                ...state,
                isLoadingDetail: true
            };
        }),
        on(
            integrationsActions.upsertIntegrationSuccess,
            (state, { integration, isDraft }) => {
                const integrations = isDraft
                    ? [...state.integrations, integration]
                    : state.integrations.map(item => item.id === integration.id ? integration : item);
                return {
                    ...state,
                    current: cloneDeep(integration),
                    creationMode: false,
                    modified: false,
                    integrations: integrations,
                    integrationDrafts: isDraft ? state.integrationDrafts.filter(
                        (p) => p.id !== integration.id
                    ) : state.integrationDrafts,
                };
            }
        ),
        on(integrationsActions.upsertIntegrationFail, (state) => {
            return {
                ...state,
                isLoadingDetail: false
            };
        }),
        on(integrationsActions.integrationChangesDiscardDraft, (state) => ({
            ...state,
            integrationDrafts: state.integrationDrafts.filter(
                (draft) => draft.id !== state.current?.id
            ),
            current: null,
            modified: false,
        })),

        on(integrationsActions.resetModuleState, (state) => {
            return {
                ...initialState
            };
        }),
        on(integrationsActions.createIntegrationDraft, (state, { draft }) => ({
            ...state,
            integrationDrafts: [...state.integrationDrafts, draft]
        })),
        on(integrationsActions.deleteIntegrationDraft, (state, { id }) => ({
            ...state,
            integrationDrafts: state.integrationDrafts.filter((p) => p.id !== id)
        })),

        on(integrationsActions.integrationChangesDiscard, (state) => {
            return {
                ...state,
                detailHeader: null
            };
        })),



});
